import {
    createSkyNetObjectRoutes,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.utils'
import ActivityRecordsDemoPage from 'app/PoC/DataGridDemoPages/ActivityRecordsDemo/ActivityRecordsDemoPage'
import domainConfig from './ActivityRecordDemo.config'

export default createSkyNetObjectRoutes(<ActivityRecordsDemoPage />, domainConfig)
